'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import type { RealEstateCatalogResponseT } from '@/forApp/types/Entity';
import LinkPagination from '@/shared/Pagination/LinkPagination';
import CatalogFilters from '@/widgets/Catalog/CatalogFilters/CatalogFilters';
import CatalogListProfile from '@/widgets/Catalog/CatalogList/CatalogListProfile';
import type { DefaultFilterT } from '@/widgets/MainBlock/MainSearch/types';
import { getRouteHref, ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

type CatalogProps = {
  defaultFilter: DefaultFilterT;
  catalog: RealEstateCatalogResponseT;
  type: string;
  setLoad: (value: boolean) => void;
};

export const Catalog: React.FC<CatalogProps> = ({
  defaultFilter,
  catalog,
  type,
  setLoad,
}) => {
  const { setIsLoading } = useApp();
  const searchParams = useSearchParams();
  useEffect(() => {
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const currentPage = catalog.entities.meta.current_page;
  const totalItems = catalog.entities.meta.total;
  const itemsPerPage = catalog.entities.meta.per_page;

  return (
    <div className={styles.catalogWrap}>
      <CatalogFilters filters={defaultFilter} setLoad={setLoad} type={type} />
      <div className={styles.catalogContent}>
        <CatalogListProfile
          catalogList={catalog.entities.data}
          typeObj={type}
        />
        {totalItems > itemsPerPage ? (
          <LinkPagination
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            basePath={getRouteHref(ROUTES.CATALOG, { type })}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Catalog;
